import React from 'react'
import { cn } from '@yanolja-rnd/nol-design-system'
import { IcError } from '@yanolja-rnd/nol-icons'

export interface ProductOutdatedProps {
  className?: string
}

/**
 * 상품 정보가 변경되었을 때 표시하는 컴포넌트
 */
const ProductOutdated: React.FC<ProductOutdatedProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'flex min-h-42 w-full items-center justify-center gap-2 rounded-8 bg-fill-warning-weak px-16 py-12 text-text-warning-main',
        className
      )}
    >
      <div className="flex gap-2">
        <IcError className="flex-shrink-0" height={16} width={16} />
        <p className="flex items-center typography-body-12-bold">
          상품 정보가 변경되었어요. 확인 후 다시 선택해 주세요.
        </p>
      </div>
    </div>
  )
}

export default ProductOutdated
